export default __webpack_public_path__ + "static/media/roomBook.016ced80.png";